import * as React from "react";
import { cn } from "../lib/utils";

// Assuming you have a cn utility for class names

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-lg border-2 border-gray-600/50 bg-gray-800/50 px-4 py-2.5 text-sm font-medium text-white ring-offset-gray-950 file:border-0 file:bg-transparent file:text-sm file:font-semibold placeholder:text-gray-400 hover:border-gray-500/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:border-orange-500/60 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300 shadow-lg backdrop-blur-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
